var _rect, _tspan, _tspan2, _g, _g2, _path, _g3, _g4, _path2, _path3, _path4, _tspan3, _tspan4, _g5, _g6, _path5, _g7, _g8, _path6, _path7, _path8, _g9, _path9, _path0, _tspan5, _tspan6, _g0, _ellipse, _ellipse2, _circle, _path1, _g1, _ellipse3, _path10, _g10, _ellipse4, _ellipse5, _path11, _g11, _path12, _rect2, _tspan7, _rect3, _g12, _rect4, _rect5, _tspan8, _tspan9, _tspan0, _tspan1, _tspan10, _tspan11, _tspan12, _tspan13, _g13, _tspan14, _path13, _path14, _path15, _path16, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _circle2, _circle3, _path17, _path18, _path19, _path20, _path21, _path22, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path23, _path24, _ellipse6, _ellipse7, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _path25, _g14, _ellipse8, _ellipse9, _g15, _rect6, _tspan41, _tspan42, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _path26, _path27, _path28, _rect7, _path29, _line, _path30, _path31, _path32, _path33, _path34, _tspan43, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _path35, _path36, _path37, _rect8, _path38, _line2, _path39, _path40, _path41, _path42, _path43, _g16, _rect9, _circle20, _path44, _circle21, _path45, _circle22, _tspan44, _rect0, _tspan45, _rect1, _tspan46, _tspan47, _tspan48, _tspan49, _rect10, _tspan50, _rect11, _tspan51;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignal2Asp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1475,
    height: 657,
    viewBox: "0 0 1475 657",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "2asp SIGNAL"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1475,
    height: 657,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CTR A5/5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CTR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 677.27,
    y: 155.54
  }, "CTR"))), /*#__PURE__*/React.createElement("text", {
    id: "CTR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 677.27,
    y: 222.109
  }, "CTR"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 697.4,
    cy: 166.871,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M700.925 166.871C700.925 169.223 699.311 171.059 697.4 171.059C695.49 171.059 693.876 169.223 693.876 166.871C693.876 164.518 695.49 162.683 697.4 162.683C699.311 162.683 700.925 164.518 700.925 166.871Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_2",
    cx: 676.011,
    cy: 166.871,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_2",
    d: "M679.536 166.871C679.536 169.223 677.922 171.059 676.012 171.059C674.102 171.059 672.487 169.223 672.487 166.871C672.487 164.518 674.102 162.683 676.012 162.683C677.922 162.683 679.536 164.518 679.536 166.871Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 17",
    d: "M679.157 166.871H694.255",
    stroke: "black",
    strokeWidth: 3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_3",
    cx: 697.4,
    cy: 232.7,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_3",
    d: "M700.925 232.7C700.925 235.052 699.311 236.888 697.4 236.888C695.49 236.888 693.876 235.052 693.876 232.7C693.876 230.348 695.49 228.512 697.4 228.512C699.311 228.512 700.925 230.348 700.925 232.7Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_4",
    cx: 676.011,
    cy: 232.7,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_4",
    d: "M679.536 232.7C679.536 235.052 677.922 236.888 676.012 236.888C674.102 236.888 672.487 235.052 672.487 232.7C672.487 230.348 674.102 228.512 676.012 228.512C677.922 228.512 679.536 230.348 679.536 232.7Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line 21",
    d: "M679.157 232.7H694.255",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 37",
    d: "M698.658 172.048H700.545L702.433 169.46V166.871V164.282L700.545 161.693H698.658",
    stroke: "black",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 38",
    d: "M698.658 237.878H700.545L702.433 235.289V232.7V230.111L700.545 227.522H698.658",
    stroke: "black",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CTR A5/7"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CTR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 677.27,
    y: 355.247
  }, "CTR"))), /*#__PURE__*/React.createElement("text", {
    id: "CTR_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 677.27,
    y: 421.816
  }, "CTR"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_5",
    cx: 697.4,
    cy: 366.578,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_5",
    d: "M700.925 366.578C700.925 368.93 699.311 370.766 697.4 370.766C695.49 370.766 693.876 368.93 693.876 366.578C693.876 364.225 695.49 362.39 697.4 362.39C699.311 362.39 700.925 364.225 700.925 366.578Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_6",
    cx: 676.011,
    cy: 366.578,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_6",
    d: "M679.536 366.578C679.536 368.93 677.922 370.766 676.012 370.766C674.102 370.766 672.487 368.93 672.487 366.578C672.487 364.225 674.102 362.39 676.012 362.39C677.922 362.39 679.536 364.225 679.536 366.578Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line 49",
    d: "M679.157 366.578H694.255",
    stroke: "black",
    strokeWidth: 3
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_7",
    cx: 697.4,
    cy: 432.407,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_7",
    d: "M700.925 432.407C700.925 434.759 699.311 436.595 697.4 436.595C695.49 436.595 693.876 434.759 693.876 432.407C693.876 430.055 695.49 428.219 697.4 428.219C699.311 428.219 700.925 430.055 700.925 432.407Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_8",
    cx: 676.011,
    cy: 432.407,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_8",
    d: "M679.536 432.407C679.536 434.759 677.922 436.595 676.012 436.595C674.102 436.595 672.487 434.759 672.487 432.407C672.487 430.055 674.102 428.219 676.012 428.219C677.922 428.219 679.536 430.055 679.536 432.407Z",
    stroke: "black",
    strokeWidth: 0.5
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Line 53",
    d: "M679.157 432.407H694.255",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 77",
    d: "M698.658 371.755H700.545L702.433 369.166V366.578V363.989L700.545 361.4H698.658",
    stroke: "black",
    strokeWidth: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 78",
    d: "M698.658 437.585H700.545L702.433 434.996V432.407V429.818L700.545 427.229H698.658",
    stroke: "black",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LOCATION BOX"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "TO_SET_LOCATION BOX"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_DG_UP_WIRE",
    d: "M898.706 182.924V166.871H702.433",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_DG_DN_WIRE",
    d: "M898.706 216.428V232.7H702.433",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_RG_UP_WIRE",
    d: "M898.706 381.631V366.578H702.433",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "LB2TRACKSIDE_RG_DN_WIRE",
    d: "M898.706 416.134V432.407H702.433",
    stroke: "black",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TO_NOT_SET_LOCATION BOX"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S1DPR"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 33",
    d: "M738.29 163.172L740.177 166.131L742.065 163.172",
    stroke: "black",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 34",
    d: "M769.115 228.262L771.002 231.221L772.89 228.262",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "DPR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 738.919,
    y: 155.54
  }, "DPR"))), /*#__PURE__*/React.createElement("text", {
    id: "DPR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 740.177,
    y: 222.109
  }, "DPR"))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_9",
    cx: 782.955,
    cy: 166.871,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_9",
    d: "M786.23 166.871C786.23 169.125 784.691 170.809 782.955 170.809C781.22 170.809 779.681 169.125 779.681 166.871C779.681 164.617 781.22 162.933 782.955 162.933C784.691 162.933 786.23 164.617 786.23 166.871Z",
    stroke: "black"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 38",
    cx: 731.37,
    cy: 166.871,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 39",
    cx: 731.37,
    cy: 232.7,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 40",
    cx: 770.856,
    cy: 166.652,
    r: 3,
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 41",
    d: "M734.645 166.871C734.645 169.125 733.106 170.809 731.37 170.809C729.635 170.809 728.096 169.125 728.096 166.871C728.096 164.617 729.635 162.933 731.37 162.933C733.106 162.933 734.645 164.617 734.645 166.871Z",
    stroke: "black"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_10",
    cx: 782.955,
    cy: 232.7,
    rx: 2.51632,
    ry: 2.95862,
    transform: "rotate(-180 782.955 232.7)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_10",
    d: "M779.681 232.7C779.681 230.446 781.219 228.762 782.955 228.762C784.691 228.762 786.229 230.446 786.229 232.7C786.229 234.954 784.691 236.638 782.955 236.638C781.219 236.638 779.681 234.954 779.681 232.7Z",
    stroke: "black"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 42",
    cx: 745.209,
    cy: 233.44,
    rx: 2.51632,
    ry: 2.95862,
    transform: "rotate(-180 745.209 233.44)",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 43",
    d: "M728.096 232.7C728.096 230.446 729.634 228.762 731.37 228.762C733.106 228.762 734.645 230.446 734.645 232.7C734.645 234.954 733.106 236.638 731.37 236.638C729.634 236.638 728.096 234.954 728.096 232.7Z",
    stroke: "black"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_11",
    cx: 782.955,
    cy: 366.578,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_11",
    d: "M786.23 366.578C786.23 368.831 784.691 370.515 782.955 370.515C781.22 370.515 779.681 368.831 779.681 366.578C779.681 364.324 781.22 362.64 782.955 362.64C784.691 362.64 786.23 364.324 786.23 366.578Z",
    stroke: "black"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 80",
    cx: 731.37,
    cy: 366.578,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 81",
    cx: 731.37,
    cy: 432.407,
    rx: 2.51632,
    ry: 2.95862,
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 83",
    d: "M734.645 366.578C734.645 368.831 733.106 370.515 731.37 370.515C729.635 370.515 728.096 368.831 728.096 366.578C728.096 364.324 729.635 362.64 731.37 362.64C733.106 362.64 734.645 364.324 734.645 366.578Z",
    stroke: "black"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2_12",
    cx: 782.955,
    cy: 432.407,
    rx: 2.51632,
    ry: 2.95862,
    transform: "rotate(-180 782.955 432.407)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_12",
    d: "M779.681 432.407C779.681 430.153 781.219 428.469 782.955 428.469C784.691 428.469 786.229 430.153 786.229 432.407C786.229 434.661 784.691 436.345 782.955 436.345C781.219 436.345 779.681 434.661 779.681 432.407Z",
    stroke: "black"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 85",
    d: "M728.096 432.407C728.096 430.153 729.634 428.469 731.37 428.469C733.106 428.469 734.645 430.153 734.645 432.407C734.645 434.661 733.106 436.345 731.37 436.345C729.634 436.345 728.096 434.661 728.096 432.407Z",
    stroke: "black"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 710.982,
    y: 116.834,
    width: 102.427,
    height: 415.166,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Location Box",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 738.92,
    y: 109.682
  }, "Location Box")))), /*#__PURE__*/React.createElement("g", {
    id: "SIGNLA UNIT"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 848,
    y: 117,
    width: 99,
    height: 415,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "TO_SET_SIGNAL UNIT"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "2ASP_LED Signal RG",
    cx: 898.851,
    cy: 399.131,
    r: 16.5,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "2ASP_LED Signal DG",
    cx: 897.851,
    cy: 199.424,
    r: 16.5,
    stroke: "black",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TO_NOT_SET_SIGNAL UNIT"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 873.285,
    y: 155.297,
    width: 48.3264,
    height: 88.2379,
    stroke: "black",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 873.285,
    y: 356.483,
    width: 48.3264,
    height: 88.2379,
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "RG",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 924,
    y: 406.636
  }, "RG"))), /*#__PURE__*/React.createElement("text", {
    id: "DG",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 925,
    y: 202.636
  }, "DG"))), /*#__PURE__*/React.createElement("text", {
    id: "HG",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 10,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 925,
    y: 202.636
  }, "HG")))), /*#__PURE__*/React.createElement("text", {
    id: "Signal Unit",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 6,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 872.285,
    y: 109.682
  }, "Signal Unit")))), /*#__PURE__*/React.createElement("g", {
    id: "RELAY RACK"
  }, /*#__PURE__*/React.createElement("text", {
    id: "DGNX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 436.961,
    y: 211.023
  }, "DGNX"))), /*#__PURE__*/React.createElement("text", {
    id: "DGBX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 436.961,
    y: 163.685
  }, "DGBX"))), /*#__PURE__*/React.createElement("text", {
    id: "RGNX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 436.961,
    y: 410.73
  }, "RGNX"))), /*#__PURE__*/React.createElement("text", {
    id: "RGBX",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 436.961,
    y: 363.392
  }, "RGBX"))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-70-inside-1_86_152",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 115.834H434.445V533H96V115.834Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96 115.834H434.445V533H96V115.834Z",
    stroke: "black",
    strokeWidth: 4,
    strokeDasharray: "2 2",
    mask: "url(#path-70-inside-1_86_152)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Relay Rack",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 252.012,
    y: 111.909
  }, "Relay Rack"))), /*#__PURE__*/React.createElement("g", {
    id: "TO_NOT_SET_RELAYRACK"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M366.505 216.428V237.138H420.606V216.428",
    stroke: "black",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 62",
    d: "M238.172 160.953L241.317 166.871L245.721 160.953",
    stroke: "black",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 63",
    d: "M262.077 209.771L265.223 215.688L269.626 209.771",
    stroke: "black",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 83",
    d: "M307.371 450.898L310.516 456.815L314.92 450.898",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "R2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 375.312,
    y: 211.023
  }, "R2"))), /*#__PURE__*/React.createElement("text", {
    id: "R1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 420.605,
    y: 211.023
  }, "R1"))), /*#__PURE__*/React.createElement("g", {
    id: "HR_RGHG"
  }, /*#__PURE__*/React.createElement("text", {
    id: "HR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 273.4,
    y: 156.288
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 313,
    y: 311.909
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 272,
    y: 383.909
  }, "HR"))), /*#__PURE__*/React.createElement("text", {
    id: "HR3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 296,
    y: 473.909
  }, "HR")))), /*#__PURE__*/React.createElement("g", {
    id: "DR_RGDG"
  }, /*#__PURE__*/React.createElement("text", {
    id: "DR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 273.4,
    y: 156.288
  }, "DR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 246.979,
    y: 203.626
  }, "DR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 241.946,
    y: 404.813
  }, "DR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 296.048,
    y: 474.34
  }, "DR")))), /*#__PURE__*/React.createElement("g", {
    id: "DECR_RGDG"
  }, /*#__PURE__*/React.createElement("text", {
    id: "DECR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 243.205,
    y: 474.34
  }, "DECR"))), /*#__PURE__*/React.createElement("text", {
    id: "DECR1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 382.86,
    y: 228.775
  }, "DECR"))), /*#__PURE__*/React.createElement("text", {
    id: "DECR2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 263.335,
    y: 311.616
  }, "DECR")))), /*#__PURE__*/React.createElement("g", {
    id: "HECR_RGHG"
  }, /*#__PURE__*/React.createElement("text", {
    id: "HECR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 242,
    y: 473.909
  }, "HECR"))), /*#__PURE__*/React.createElement("text", {
    id: "HECR1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 383,
    y: 228.909
  }, "HECR")))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    cx: 266.077,
    cy: 167.912,
    r: 4,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 239.656,
    cy: 217.25,
    r: 4,
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 64",
    d: "M366.505 416.134V436.845H420.606V416.134",
    stroke: "black",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 65",
    d: "M283.466 330.334L279.691 324.417L275.917 330.334",
    stroke: "black",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 66",
    d: "M241.946 374.714L238.172 368.797L234.397 374.714",
    stroke: "black",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 82",
    d: "M259.561 464.952L255.786 459.034L252.012 464.952",
    stroke: "black",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 67",
    d: "M263.335 424.271L258.931 418.353L255.786 424.271",
    stroke: "black",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 69",
    d: "M234.397 330.334L238.172 324.417L241.946 330.334",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "0.6A",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 194.137,
    y: 354.516
  }, "0.6A"))), /*#__PURE__*/React.createElement("text", {
    id: "R2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 376.569,
    y: 410.73
  }, "R2"))), /*#__PURE__*/React.createElement("text", {
    id: "R1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 421.863,
    y: 410.73
  }, "R1"))), /*#__PURE__*/React.createElement("text", {
    id: "DR_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 313.662,
    y: 311.616
  }, "DR"))), /*#__PURE__*/React.createElement("text", {
    id: "DR_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 272.143,
    y: 384.102
  }, "DR"))), /*#__PURE__*/React.createElement("text", {
    id: "RECR",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 382.86,
    y: 428.481
  }, "RECR"))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 67",
    cx: 263.561,
    cy: 367.14,
    r: 4,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 97",
    cx: 234.623,
    cy: 458.857,
    r: 4,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98",
    cx: 288.724,
    cy: 457.378,
    r: 4,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 70",
    cx: 256.012,
    cy: 323.24,
    r: 4,
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 71",
    cx: 234.623,
    cy: 416.436,
    r: 4,
    fill: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 74",
    cx: 307.597,
    cy: 323.24,
    r: 4,
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 80",
    d: "M238.172 368.796L226.849 360.216V323.973H327.501V360.216H279.062L267.11 366.873",
    stroke: "black",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 81",
    d: "M258.643 417.318L271.744 423.975L329.389 422.791V456.815L224.332 459.034V422.791L233.69 416.134",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 94",
    cx: 190.991,
    cy: 169.829,
    rx: 1.88724,
    ry: 2.21897,
    fill: "black"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 95",
    cx: 211.122,
    cy: 169.829,
    rx: 1.88724,
    ry: 2.21897,
    fill: "black"
  })), /*#__PURE__*/React.createElement("text", {
    id: "0.6A_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 194.137,
    y: 154.809
  }, "0.6A"))), /*#__PURE__*/React.createElement("text", {
    id: "BX110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 158.908,
    y: 172.561
  }, "BX110"))), /*#__PURE__*/React.createElement("text", {
    id: "NX110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 158.908,
    y: 221.378
  }, "NX110"))), /*#__PURE__*/React.createElement("text", {
    id: "BX110_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 158.908,
    y: 372.268
  }, "BX110"))), /*#__PURE__*/React.createElement("text", {
    id: "NX110_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 158.908,
    y: 421.085
  }, "NX110"))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Line 137",
    d: "M191.62 169.829C191.62 169.829 196.388 158.18 201.685 169.829C206.983 181.479 211.751 169.829 211.751 169.829",
    stroke: "black",
    strokeWidth: 2
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group 128"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 100",
    cx: 190.992,
    cy: 369.536,
    rx: 1.88724,
    ry: 2.21897,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 101",
    cx: 211.123,
    cy: 369.536,
    rx: 1.88724,
    ry: 2.21897,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 138",
    d: "M191.621 369.536C191.621 369.536 196.389 357.887 201.686 369.536C206.984 381.186 211.752 369.536 211.752 369.536",
    stroke: "black",
    strokeWidth: 2
  }))), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 99",
    cx: 189.733,
    cy: 218.647,
    rx: 1.88724,
    ry: 2.21897,
    fill: "black"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 100_2",
    cx: 189.733,
    cy: 418.353,
    rx: 1.88724,
    ry: 2.21897,
    fill: "black"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "TO_SET_RELAYRACK"
  }, /*#__PURE__*/React.createElement("path", {
    id: "RR_UP_WIRE_DG",
    d: "M503.644 166.871L190.361 169.046",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "RR_DN_WIRE_DG",
    d: "M503.644 215.688L190.362 217.916",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 64",
    d: "M503.644 215.688L190.362 217.916",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "RR_UP_WIRE_RG",
    d: "M503.644 366.578L190.361 368.753",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "RR_UP_WIRE_RG_2",
    d: "M503.644 415.395L190.362 417.623",
    stroke: "black",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "CT RACK"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 478.223,
    y: 116.834,
    width: 177.917,
    height: 415.166,
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CTR_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 552.712,
    y: 111.909
  }, "CTR"))), /*#__PURE__*/React.createElement("g", {
    id: "TO_NOT_SET_CT RACK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B18 SPD"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SPD",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 502.386,
    y: 148.892
  }, " SPD"))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 505.128,
    cy: 166.433,
    r: 4,
    fill: "black"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 526.517,
    cy: 166.433,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 505.128,
    cy: 215.25,
    r: 4,
    fill: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 35",
    cx: 526.517,
    cy: 215.25,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 505.128,
    cy: 235.96,
    r: 4,
    fill: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 37",
    cx: 526.517,
    cy: 235.96,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Line 18",
    d: "M507.418 166.871H523.145",
    stroke: "black",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Line 19",
    d: "M507.418 215.688H523.145",
    stroke: "black",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Line 20",
    d: "M507.418 236.398H523.145",
    stroke: "black",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    x: 493.32,
    y: 155.297,
    width: 44.5519,
    height: 94.1552,
    stroke: "black",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Line 24",
    d: "M516.226 257.109V237.097",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line 25",
    x1: 509.935,
    y1: 256.848,
    x2: 522.516,
    y2: 256.848,
    stroke: "black",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Line 26",
    d: "M511.193 258.403H521.65",
    stroke: "black",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Line 27",
    d: "M512.451 259.032H520",
    stroke: "black",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Line 28",
    d: "M513.709 259.697H518.742",
    stroke: "black",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Line 29",
    d: "M514.968 260.511H517.484",
    stroke: "black",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Line 32",
    d: "M513.709 259.697H518.742",
    stroke: "black",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "B20SPD"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SPD_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 502.386,
    y: 348.599
  }, " SPD"))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 66",
    cx: 505.128,
    cy: 366.14,
    r: 4,
    fill: "black"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 75",
    cx: 526.517,
    cy: 366.14,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76",
    cx: 505.128,
    cy: 414.957,
    r: 4,
    fill: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 77",
    cx: 526.517,
    cy: 414.957,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 78",
    cx: 505.128,
    cy: 435.667,
    r: 4,
    fill: "black"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 79",
    cx: 526.517,
    cy: 435.667,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Line 50",
    d: "M507.418 366.578H523.145",
    stroke: "black",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Line 51",
    d: "M507.418 415.395H523.145",
    stroke: "black",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Line 52",
    d: "M507.418 436.105H523.145",
    stroke: "black",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 493.32,
    y: 355.003,
    width: 44.5519,
    height: 94.1552,
    stroke: "black",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Line 56",
    d: "M516.226 456.815V436.804",
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line 57",
    x1: 509.935,
    y1: 456.555,
    x2: 522.516,
    y2: 456.555,
    stroke: "black",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Line 58",
    d: "M511.193 458.11H521.65",
    stroke: "black",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Line 59",
    d: "M512.451 458.739H520",
    stroke: "black",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Line 60",
    d: "M513.709 459.404H518.742",
    stroke: "black",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Line 61",
    d: "M514.968 460.218H517.484",
    stroke: "black",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Line 64_2",
    d: "M513.709 459.404H518.742",
    stroke: "black",
    strokeWidth: 2
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "TO_SET_CT RACK"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_DG_DN_WIRE",
    d: "M550.195 232.7L672.237 232.7",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_DG_DN_WIRE_2",
    d: "M530.065 215.688H550.196V233.44",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_RG_DN_WIRE",
    d: "M550.195 432.407L672.237 432.407",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_RG_DN_WIRE_2",
    d: "M530.065 415.395H550.196V433.147",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "SPD2CTR_MONITOR_RG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_RG_UP_WIRE",
    d: "M530.064 366.578H671.877",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "SPD2CTR_MONITOR_DG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SPD2CTR_DG_UP_WIRE",
    d: "M529.436 166.871H673.136",
    stroke: "black",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 6"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 373,
    height: 417,
    transform: "translate(998 116)",
    fill: "black"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 156",
    cx: 1185,
    cy: 340,
    r: 25,
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 172",
    d: "M1150.5 261.5C1150.5 242.722 1165.72 227.5 1184.5 227.5C1203.28 227.5 1218.5 242.722 1218.5 261.5V393.5H1150.5V261.5Z",
    stroke: "white",
    strokeWidth: 3
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 155",
    cx: 1185,
    cy: 274,
    r: 25,
    fill: "black",
    stroke: "white",
    strokeWidth: 2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "SG_DG",
    d: "M1204 273.5C1204 284.293 1195.47 293 1185 293C1174.53 293 1166 284.293 1166 273.5C1166 262.707 1174.53 254 1185 254C1195.47 254 1204 262.707 1204 273.5Z",
    fill: "#979393",
    stroke: "white",
    strokeWidth: 2
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "SG_RG",
    cx: 1185,
    cy: 340,
    r: 19,
    fill: "#979393",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "VRG",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 1239,
    y: 283.864
  }))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 177",
    x: 1228.5,
    y: 237.5,
    width: 127,
    height: 160,
    rx: 4.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "DPR_3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 1018,
    y: 283.864
  }))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 178",
    x: 1010.5,
    y: 237.5,
    width: 127,
    height: 160,
    rx: 4.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SG_NAME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 1269,
    y: 163.864
  }))), /*#__PURE__*/React.createElement("text", {
    id: "LOC_NAME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 12,
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 1018,
    y: 163.864
  }))), /*#__PURE__*/React.createElement("text", {
    id: "PROVING_RELAY_TIME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 1014,
    y: 255.909
  }))), /*#__PURE__*/React.createElement("text", {
    id: "ASPECT_TIME",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 1235,
    y: 255.909
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 190",
    x: 1090,
    y: 248,
    width: 43,
    height: 11.1961,
    rx: 5,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "RELAY",
    transform: "translate(1097 248)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.90909
  }, "RELAY"))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 191",
    x: 1311,
    y: 248,
    width: 43,
    height: 11.1961,
    rx: 5,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MAIN",
    transform: "translate(1323 248)",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.90909
  }, "MAIN"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal2Asp);
export default __webpack_public_path__ + "static/media/signal_2asp.1315fa4a89d60dc1bc9bc30b02d11018.svg";
export { ForwardRef as ReactComponent };